
import Vue from 'vue';
import { RunnitDynamicFieldMixin } from '@/views/Runnits/RunnitSettings/mixins/RunnitDynamicFieldMixin';
import { getLogicOnFieldsFromField } from '@run-diffusion/shared';
import { mapActions } from 'vuex';
import { SNACKBAR_STATUS } from '@/constants/constants';
import RunnitDynamicFieldLabelRow from '@/views/Runnits/RunnitSettings/RunnitDynamicFieldLabelRow.vue';
import _isNil from 'lodash/isNil';

export default Vue.extend({
	name: 'RunnitTextField',
	mixins: [
		RunnitDynamicFieldMixin,
	],
	props: {
		field: { type: Object, required: true },
		value: { type: String, default: null },
		adminOnly: { type: Boolean, default: false },
		inputValues: { type: Object, required: true },
	},
	data () {
		return {};
	},
	computed: {
		logicOnFields () {
			return getLogicOnFieldsFromField(this.field, this.inputValues);
		},
		autoSetValue () {
			return this.logicOnFields.autoSetValue;
		},
	},
	watch: {
		autoSetValue: {
			handler (newValue: any, oldValue: any) {
				// If autoSet value changes, update the field value
				if (!_isNil(newValue) && newValue !== oldValue) {
					this.onFieldInput(newValue);
				}
			},
			immediate: true,
		},
		autoSetError: {
			handler (newVal: string, oldVal: string) {
				if (newVal && newVal !== oldVal) {
					this.updateSnackbar({
						status: SNACKBAR_STATUS.ERROR,
						message: newVal,
						show: true,
					});
				}
			},
			immediate: true,
		},
	},
	methods: {
		...mapActions([
			'updateSnackbar',
		]),
		onFieldInput (val: any) {
			// If field has autoSet value and editing is not allowed, use autoSet value
			if (_isNil(this.logicOnFields.autoSetValue) || this.logicOnFields.autoSetAllowEdit) {
				// Use the user's input value (either manual input or autoSet with allowEdit)
				this.$emit('input', val);
			} else {
				this.$emit('input', this.logicOnFields.autoSetValue);
			}
		},
	},
	components: {
		RunnitDynamicFieldLabelRow,
	},
});
